import { memo, } from "react";
import CheckboxPermitPDF from "../inputs/CheckboxPermitPDF";

interface PermitRequirementsProps {
  sectionNumber: number;
  safetyChecklist: {
    titleEn: string;
    titleAr: string;
    items: {
      id: string;
      titleEn: string;
      titleAr: string;
      checked: boolean;
    }[];
  }[];
}

const PermitRequirements = ({ sectionNumber, safetyChecklist }: PermitRequirementsProps) => {
  return (
    <div>
      <div className="bg-green-primary text-center border-b border-black py-0.5">
        <span className="text-[10px] font-bold text-white">
          Section {sectionNumber}: Requirements
        </span>
      </div>

      <div className="grid grid-cols-2">
        {safetyChecklist.map((section) => (
          <div key={section.titleEn} className="border-r border-t border-l border-black ">
            <div className="bg-gray-100 border-b border-black p-1 text-[10px] font-bold">
              {section.titleEn}
            </div>
            <div>
              {section.items.map((item) => (
                <CheckboxPermitPDF
                  key={item.id}
                  item={{
                    key: item.id,
                    label: item.titleEn
                  }}
                  isLastColumn={false}
                  checked={item.checked}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

};

export default memo(PermitRequirements);
